"use strict";
exports.__esModule = true;
var React = require("react");
var GoogleMapTextLabel_1 = require("../components/GoogleMapTextLabel");
var uuid = require("uuid");
var format_1 = require("./format");
var getIndex = function (start, end, length, target) {
    if (target < start)
        return -1;
    for (var i = start, j = 0; i < end + length; i += length, j += 1) {
        if (target > i)
            continue;
        return j;
    }
    return -1;
};
var getCoord = function (map, lagLng, gridSize) {
    var mapContainerLength = map.getDiv().clientWidth;
    var pinPoint = map.getProjection().fromLatLngToPoint(new google.maps.LatLng(lagLng.lat, lagLng.lng));
    var nePoint = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
    var swPoint = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
    var mapLength = Math.abs(nePoint.x - swPoint.x);
    var scale = mapContainerLength / mapLength;
    var gridLength = gridSize / scale;
    var lat = getIndex(swPoint.x, nePoint.x, gridLength, pinPoint.x);
    var lng = getIndex(nePoint.y, swPoint.y, gridLength, pinPoint.y);
    return {
        lat: lat,
        lng: lng
    };
};
var coordToKey = function (coord) { return coord.lat + "-" + coord.lng; };
var keyToCoord = function (key) {
    var coordPcs = key.split('-');
    return { lat: Number(coordPcs[0]), lng: Number(coordPcs[1]) };
};
var getAverageLocation = function (locations) {
    var xSum = 0;
    var ySum = 0;
    locations.map(function (it) {
        xSum += it.lat;
        ySum += it.lng;
    });
    return { lat: xSum / locations.length, lng: ySum / locations.length };
};
var getRangeTitle = function (values) {
    var avg = format_1.toPrice(values.reduce(function (acc, it) { return acc + it; }, 0) / values.length);
    return "~" + avg;
};
var gridInfoToChildren = function (gridInfo, map) {
    var newChildrenInfo = [];
    Object.entries(gridInfo).map(function (_a) {
        var gridKey = _a[0], gridNodes = _a[1];
        newChildrenInfo.push({
            coord: keyToCoord(gridKey),
            children: gridNodes,
            center: getAverageLocation(gridNodes.map(function (it) { return it.props.center; }))
        });
    });
    return newChildrenInfo.map(function (it, i) {
        if (it.children.length === 1)
            return it.children[0];
        var onGroupLabelClicked = function () {
            var childrenProps = it.children.map(function (it2) { return it2.props; });
            if (it.children[0].props.onClick)
                it.children[0].props.onClick(childrenProps);
            map.setZoom(map.getZoom() + 1);
            var clickCenter = it.children[0].props.center;
            map.setCenter({ lat: clickCenter.lat, lng: clickCenter.lng });
        };
        var firstChild = it.children[0];
        var firstChildProps = firstChild.props;
        var id = uuid();
        var rangeTitle = getRangeTitle(it.children.map(function (it) { return it.props.value; }).filter(function (it) { return it; }));
        var hasActive = it.children.map(function (it2) { return it2.props; }).reduce(function (acc, props) { return acc || props.active; }, false);
        return (React.createElement(GoogleMapTextLabel_1.GoogleMapTextLabel, { active: hasActive, onClick: onGroupLabelClicked, key: id, title: rangeTitle, count: it.children.length, center: firstChildProps.center }));
    });
};
var doClusterMarkers = function (map, children) {
    if (!map)
        return children;
    if (!children || !children.length)
        return children;
    var gridInfo = {};
    var GRID_SIZE = 100;
    children.map(function (it) {
        var lagLng = it.props.center;
        var coord = getCoord(map, lagLng, GRID_SIZE);
        var key = coordToKey(coord);
        if (!gridInfo[key]) {
            gridInfo[key] = [];
        }
        gridInfo[key].push(it);
    });
    return gridInfoToChildren(gridInfo, map);
};
exports.doClusterMarkers = doClusterMarkers;
